import { render, staticRenderFns } from "./login-layout.vue?vue&type=template&id=5ec983d0&scoped=true&"
import script from "./login-layout.vue?vue&type=script&lang=ts&"
export * from "./login-layout.vue?vue&type=script&lang=ts&"
import style0 from "./login-layout.vue?vue&type=style&index=0&id=5ec983d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec983d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\i\\au_kyujin_web\\src\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec983d0')) {
      api.createRecord('5ec983d0', component.options)
    } else {
      api.reload('5ec983d0', component.options)
    }
    module.hot.accept("./login-layout.vue?vue&type=template&id=5ec983d0&scoped=true&", function () {
      api.rerender('5ec983d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/components/login-layout.vue"
export default component.exports